import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import {
  fetchServicesPassengersConcernedByCommunication,
  fetchedServicesPassengersConcernedByCommunication,
} from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchServicesPassengersConcernedByCommunicationPayload = ReturnType<
  typeof fetchServicesPassengersConcernedByCommunication
>;

export function* getServicesPassengersConcernedByCommunicationSaga({
  payload,
  meta: { callback },
}: FetchServicesPassengersConcernedByCommunicationPayload) {
  const { getServicesPassengersConcernedByCommunication } = getAPI();
  const response: YieldOf<typeof getServicesPassengersConcernedByCommunication> = yield call(
    getServicesPassengersConcernedByCommunication,
    payload
  );
  const { data, ok, problem, status } = response;

  if (!ok) {
    if (status === 401 || status === 403) {
      yield put(logout());
      return;
    }

    const error = problem || 'unknown';
    if (status === 412) {
      yield put(fetchedServicesPassengersConcernedByCommunication(data, error));
      return;
    }

    yield put(fetchedServicesPassengersConcernedByCommunication(undefined, error));
    return;
  }

  yield put(fetchedServicesPassengersConcernedByCommunication(data));
  if (callback) callback(data);
}

export default function* communicationStatusSaga() {
  yield takeLatest(
    fetchServicesPassengersConcernedByCommunication.type,
    getServicesPassengersConcernedByCommunicationSaga
  );
}
